import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { isValidZipCode } from "../../helpers/utilities";
import { DiliTextCP } from "../Utility/DiliTextCP";

export const ClientAddressEdit = ({
  show,
  onHide,
  address,
  suite = "",
  city,
  state,
  zip,
  finishEditingAddress,
  editAddress,
  saveChanges,
  initialAddress,
  ...props
}) => {
  const [editingValues, setEditingValues] = useState({
    address,
    suite,
    city,
    state,
    zip,
  });

  //when values change in the parent, update in here, (shorthand syntax to pass in prop names and values at once)
  useEffect(() => {
    setEditingValues({ address, suite, city, state, zip });
  }, [address, suite, city, state, zip]);

  const handleCloseWithoutFinish = () => {
    onHide();
    //reset editting values when we hide/cancel
    setEditingValues(initialAddress);
    finishEditingAddress(initialAddress);
    // setEditingValues({ address, suite, city, state, zip });
  };

  const onChangeEditValues = (e) => {
    setEditingValues((prevEditingValues) => {
      return { ...prevEditingValues, [e.target.name]: e.target.value };
    });
    //reworking this haphazardly to get rid of two step saving. (Previously you had to finish editing the address, then could reset or save afterwards. Now when you finish it saves.) (had to change a bunch of stuff on the client profile page, just making the comment here. prob would benefit from a total rework)
    editAddress({ ...editingValues, [e.target.name]: e.target.value });
  };

  //pass the edited values to parent's callback on finish
  const finish = async () => {
    await saveChanges();
    finishEditingAddress(editingValues);
  };

  const checkFieldsValid = () => {
    let isValid = true;
    if (!editingValues.address.length > 0) {
      isValid = false;
    }
    if (!editingValues.city.length > 0) {
      isValid = false;
    }
    if (!editingValues.state.length > 0) {
      isValid = false;
    }
    if (!isValidZipCode(editingValues.zip)) {
      isValid = false;
    }
    return isValid;
  };

  const isValid = checkFieldsValid();

  return (
    <Modal
      show={show}
      onHide={handleCloseWithoutFinish}
      {...props}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>Editing Address</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-row">
          <DiliTextCP
            className="col-md-9 form-group"
            required
            maxLength={150}
            autoFocus
            label="Address"
            name="address"
            value={editingValues.address}
            onChange={onChangeEditValues}
          />
          <div className="col-md-3 form-group">
            <label>
              Suite <small className="text-note">(optional)</small>
            </label>
            <input
              className="form-control"
              maxLength={25}
              name="suite"
              value={editingValues.suite}
              onChange={onChangeEditValues}
            />
          </div>
          <DiliTextCP
            className="col-md-12 form-group"
            required
            maxLength={25}
            label="City"
            name="city"
            value={editingValues.city}
            onChange={onChangeEditValues}
          />
          <DiliTextCP
            className="col-md-6 form-group"
            required
            type="select"
            label="State"
            name="state"
            value={editingValues.state}
            onChange={onChangeEditValues}
          >
            <option value="">Select State</option>
            <option value="AL">AL</option>
            <option value="AK">AK</option>
            <option value="AZ">AZ</option>
            <option value="AR">AR</option>
            <option value="CA">CA</option>
            <option value="CO">CO</option>
            <option value="CT">CT</option>
            <option value="DE">DE</option>
            <option value="FL">FL</option>
            <option value="GA">GA</option>
            <option value="HI">HI</option>
            <option value="ID">ID</option>
            <option value="IL">IL</option>
            <option value="IN">IN</option>
            <option value="IA">IA</option>
            <option value="KS">KS</option>
            <option value="KY">KY</option>
            <option value="LA">LA</option>
            <option value="ME">ME</option>
            <option value="MD">MD</option>
            <option value="MA">MA</option>
            <option value="MI">MI</option>
            <option value="MN">MN</option>
            <option value="MS">MS</option>
            <option value="MO">MO</option>
            <option value="MT">MT</option>
            <option value="NE">NE</option>
            <option value="NV">NV</option>
            <option value="NH">NH</option>
            <option value="NJ">NJ</option>
            <option value="NM">NM</option>
            <option value="NY">NY</option>
            <option value="NC">NC</option>
            <option value="ND">ND</option>
            <option value="OH">OH</option>
            <option value="OK">OK</option>
            <option value="OR">OR</option>
            <option value="PA">PA</option>
            <option value="RI">RI</option>
            <option value="SC">SC</option>
            <option value="SD">SD</option>
            <option value="TN">TN</option>
            <option value="TX">TX</option>
            <option value="UT">UT</option>
            <option value="VT">VT</option>
            <option value="VA">VA</option>
            <option value="WA">WA</option>
            <option value="WV">WV</option>
            <option value="WI">WI</option>
            <option value="WY">WY</option>
          </DiliTextCP>
          <DiliTextCP
            className="col-md-6"
            required
            label="Zip"
            name="zip"
            value={editingValues.zip}
            onChange={onChangeEditValues}
            validationTest={isValidZipCode}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-secondary"
          onClick={handleCloseWithoutFinish}
        >
          Cancel
        </button>
        <button
          className="btn btn-primary"
          onClick={finish}
          disabled={!isValid}
        >
          Finish
        </button>
      </Modal.Footer>
    </Modal>
  );
};
